import React from "react";
import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { PageListBean } from "../ds/client_ds.js";
import {
  ProductStatusBean,
  ProductStatusSearchCriteria,
  RestProductStatusListRequest,
  RestReadRequest,
} from "../ds/ds.js";
import { DropDwnDown, DropDwnUp } from "../gui_components/Icons.js";
import {
  AlertToolBox,
  InputCheckbox,
  InputTextbox,
  ShowError,
} from "../gui_components/UIComponents.js";
import { isEmptyArray } from "../gui_components/Util.js";
import {
  BaseInquiryPageListToolBar,
  BaseInquiryToolBar,
  BaseToolBar,
} from "../modules/BaseModule.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { MasterService } from "../services/MasterService.js";
class ProductStatusListForm extends React.Component {
  constructor(props) {
    super(props);
    this.listFormCodeRef = React.createRef();
  }

  componentDidMount() {}

  componentDidUpdate() {
    this.setInputFocus();
  }
  setInputFocus() {
    if (this.listFormCodeRef.current != null) {
      this.listFormCodeRef.current.focus();
    }
  }
  editProductStatus = (e, val, rowData) => {
    if (e.detail === 1) this.props.editProductStatus(val, rowData);
  };
  onChange = (e) => {
    this.props.onChange(e);
  };
  goButton = (e) => {
    if (e.detail === 1) this.props.goButton();
  };
  handleSortingChange = (e, accessor) => {
    if (e.detail === 1) this.props.handleSortingChange(accessor);
  };
  render() {
    let productStatus_list = this.props.productStatus_list;
    let productStatusData = this.props.productStatusData;

    return (
      <div>
        <Row>
          <Col sm="2">
            <FormLabel id="searchBarLabel">Product Status</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              type="text"
              name="code"
              onChange={this.onChange}
              value={productStatusData.code}
              style={{ "text-transform": "uppercase" }}
              enterKeyEventHandler={this.props.enterKeyEventHandler}
              ref={this.listFormCodeRef}
              isMandatory={true}
            ></InputTextbox>
          </Col>

          <Col sm="1">
            <Button
              id="fabric_Add_Button"
              className="text-center"
              onClick={(e) => this.goButton(e)}
            >
              Go
            </Button>
          </Col>
        </Row>
        <br />

        <div className="div_default">
          <Table id="fabrics_tables_default">
            <thead>
              <tr>
                <th onClick={(e) => this.handleSortingChange(e, "code")}>
                  Code{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "code" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "description")}>
                  Name{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "description" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "companyCode")}>
                  CompanyCode{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "companyCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "isActive")}>
                  Active{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "isActive" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
              </tr>
            </thead>
            <tbody>
              {productStatus_list.map((Info, index) => (
                <tr key={index}>
                  <td>
                    <Button
                      variant="secondry"
                      className="hyperLinkText"
                      onClick={(e) =>
                        this.editProductStatus(e, Info.code, Info)
                      }
                    >
                      {Info.code}
                    </Button>
                  </td>

                  <td> {Info.description}</td>
                  <td>{Info.companyCode}</td>
                  <td>{Info.isActive}</td>
                </tr>
              ))}
            </tbody>
          </Table>
          {productStatus_list.length != 0 ? null : (
            <div className="no_Data">{"NO DATA"}</div>
          )}
        </div>
      </div>
    );
  }
}

class ProductStatusEntryForm extends React.Component {
  constructor(props) {
    super(props);
    this.codeRef = React.createRef();
  }

  componentDidMount() {
    this.setInputFocus();
  }
  setInputFocus() {
    if (this.codeRef.current != null) {
      this.codeRef.current.focus();
    }
  }
  onChange = (e) => {
    this.props.onChange(e);
  };

  saveProductStatus = (e) => {
    this.props.saveProductStatus(this.state.productStatusData);
  };

  render() {
    let productStatusData = this.props.productStatusData;
    let isDisabledFields = this.props.isDisableFields;
    return (
      <div>
        <Row>
          <Col sm="1">
            {" "}
            <FormLabel>Company Code</FormLabel>{" "}
          </Col>
          <Col sm="2">
            {" "}
            <InputTextbox
              name="companyCode"
              type="text"
              placeholder="Enter CompanyCode"
              value={productStatusData.companyCode}
              disabled={true}
            />{" "}
          </Col>
          <Col sm="2">
            {" "}
            <FormLabel>Product Status Code</FormLabel>{" "}
          </Col>
          <Col sm="2">
            {" "}
            <InputTextbox
              ref={this.codeRef}
              name="code"
              type="text"
              placeholder="Enter ProductStatusCode"
              onChange={this.onChange}
              value={productStatusData.code}
              style={{ "text-transform": "uppercase" }}
              disabled={isDisabledFields}
              isMandatory={true}
            />{" "}
          </Col>
          <Col sm="2">
            <FormLabel>Product Status Name</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <InputTextbox
              name="description"
              type="text"
              placeholder="Enter Name"
              onChange={this.onChange}
              value={productStatusData.description}
              style={{ "text-transform": "capitalize" }}
              isMandatory={true}
            />
          </Col>
        </Row>
        <Row>
          <Col sm="1">
            <FormLabel>isOrderAllow</FormLabel>
          </Col>
          <Col sm="2">
            {" "}
            <InputCheckbox
              type="checkbox"
              name="orderAllowed"
              onChange={this.onChange}
              checked={productStatusData.orderAllowed}
            />
          </Col>
          <Col sm="1">
            <FormLabel>Active</FormLabel>
          </Col>
          <Col sm="1" className="productStatusCheckBox">
            {" "}
            <InputCheckbox
              type="checkbox"
              name="isActive"
              onChange={this.onChange}
              checked={productStatusData.isActive}
            />
          </Col>
        </Row>

        <br />
      </div>
    );
  }
}

class ProductStatusList extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      productStatus_list: [],
      response: {},
      pageTitle: "Product Status",
      productStatusData: new ProductStatusBean(),
      pageList: new PageListBean(),
      criteria: new ProductStatusSearchCriteria(),
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: false,
      isShowBackButton: false,
      error_list: [],
      totalCount: 0,
      isProductStatusListFormOpen: true,
      isProductStatusEntryFormOpen: false,
      isShowNodes: false,
      selectedNode: "headerView",
      alertMessage: [],
      alertType: "",
      isShowAlert: false,
      isDisableFields: false,
      isShowExitButton: true,
      isPageListToolBar: true,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      order: "asc",
      sortField: "",
    };
    this.moduleCaption = "Product Status";
  }

  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    let productStatusData = new ProductStatusBean();
    productStatusData.companyCode = this.companyCode;
    this.setState({ productStatusData: productStatusData });
    this.loadPage(1);
    this.cleardata();
  }
  cleardata = () => {
    let productStatusData = new ProductStatusBean();
    productStatusData.companyCode = this.companyCode;
    this.setState({ productStatusData: productStatusData });
  };
  saveProductStatusResponse = (response) => {
    this.handleresponse(response.data);
    this.clearError();
    this.cleardata();
    this.closeProductStatusEntryForm();
  };

  saveProductStatus = () => {
    let productStatus = this.state.productStatusData;
    if (productStatus.isFetched == true) {
      if (SecurityAccessManager.ProductStatusMaintenanceEdit_IsAccessible()) {
        MasterService.updateProductStatus(
          productStatus,
          this.saveProductStatusResponse,
          this.errorCallBack
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    } else {
      if (SecurityAccessManager.ProductStatusMaintenanceCreate_IsAccessible()) {
        MasterService.createProductStatus(
          productStatus,
          this.saveProductStatusResponse,
          this.errorCallBack
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };
  editProductStatusResponse = (response) => {
    if (response.data != null) {
      if (response.data.productStatus != null) {
        let productStatusData = response.data.productStatus;
        this.setState({
          productStatusData: productStatusData,
        });
        this.disable();
      }
    }
    this.openProductStatusEntryForm();
  };

  goButton = () => {
    let productStatusData = this.state.productStatusData;
    this.editProductStatus(productStatusData.code);
  };
  enterKeyEventHandler = (e) => {
    e.preventDefault();
    setTimeout(() => {
      this.goButton();
    }, 200);
  };

  editProductStatus = (code) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = code;
    if (SecurityAccessManager.ProductStatusMaintenanceView_IsAccessible()) {
      MasterService.readProductStatus(
        readrestInput,
        this.editProductStatusResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  onChange = (e) => {
    let productStatusData = this.state.productStatusData;
    productStatusData[e.target.name] = e.target.value;
    this.setState({ productStatusData: productStatusData });
  };

  handleresponse = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }

    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  save = () => {
    this.saveProductStatus();
  };

  back = () => {
    this.clearError();
    this.cleardata();
    this.hideAlertCallBack(false);
    this.closeProductStatusEntryForm();
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  openProductStatusEntryForm = () => {
    this.setState({
      isProductStatusListFormOpen: false,
      isProductStatusEntryFormOpen: true,
      isShowSaveButton: true,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: true,
      isShowBackButton: true,
      isShowNodes: false,
      isPageListToolBar: false,
      isLoadFirstButton: false,
      isLoadLastButton: false,
      isLoadPreviousButton: false,
      isLoadNextButton: false,
    });
    this.hideAlertCallBack();
  };

  closeProductStatusEntryForm = () => {
    this.clearError();
    let pageTitle = this.moduleCaption;
    this.setState({
      isProductStatusListFormOpen: true,
      isProductStatusEntryFormOpen: false,
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowBackButton: false,
      isShowClearErrorButton: false,
      pageTitle: pageTitle,
      isShowNodes: false,
      isPageListToolBar: true,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isDisableFields: false,
    });
  };

  moduleExit = () => {
    this.props.onModuleExit();
  };

  loadProductStatusResponse = (response) => {
    if (response.data != null && response.data.attributePageList != null) {
      let attributes = new Array();
      if (!isEmptyArray(response.data.attributePageList.attributes)) {
        attributes = response.data.attributePageList.attributes;
        attributes.map((Info) => {
          if (Info.isActive == true) {
            Info.isActive = "True";
          } else {
            Info.isActive = "False";
          }
        });
      }
      let pageList = this.state.pageList;
      pageList.currentPage = response.data.attributePageList.currentPage;
      pageList.pageSize = response.data.attributePageList.pageSize;
      pageList.totalCount = response.data.attributePageList.totalCount;
      this.setState({
        productStatus_list: attributes,
        pageList: pageList,
      });
    }
  };

  loadFirst = () => {
    this.loadPage(1);
  };
  loadPrevious = () => {
    let currentPage = this.state.pageList.currentPage;
    let previousPage = currentPage - 1;
    this.loadPage(previousPage);
  };
  loadNext = () => {
    let currentPage = this.state.pageList.currentPage;
    let nextPage = currentPage + 1;
    this.loadPage(nextPage);
  };

  loadLast = () => {
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    let totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    this.loadPage(totalPages);
  };

  loadPage = (pageNumber) => {
    let criteria = new ProductStatusSearchCriteria();
    criteria.companyCode = this.companyCode;
    let pageList = this.state.pageList;
    let pageInput = new PageListBean();
    pageInput.pageSize = 50;
    pageInput.currentPage = pageNumber;
    if (pageList != null) pageInput.totalCount = pageList.totalCount;
    this.state.pageList = pageInput;
    this.loadProductStatusPage(pageInput, criteria);
  };
  loadProductStatusPage = (pageList, criteria) => {
    let requestInput = new RestProductStatusListRequest();
    requestInput.pageInput = pageList;
    requestInput.searchCriteria = criteria;
    this.state.pageList = pageList;
    if (SecurityAccessManager.ProductStatusMaintenanceView_IsAccessible()) {
      MasterService.getProductStatusPageListByCriteria(
        requestInput,
        this.loadProductStatusResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  errorCallBack = (error) => {
    ShowError("Error : " + error);
  };
  handleSortingChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSorting(sortField, sortOrder);
  };
  handleSorting = (sortField, sortOrder) => {
    let list = this.state.productStatus_list;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ productStatus_list: sorted });
    }
  };
  render() {
    let pageList = this.state.pageList;
    let totalPages = 0;
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    let currentPage = pageList.currentPage;

    return (
      <div>
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        {this.state.isPageListToolBar && (
          <BaseInquiryPageListToolBar
            currentPage={currentPage}
            totalPages={totalPages}
            isLoadFirstButton={this.state.isLoadFirstButton}
            isLoadLastButton={this.state.isLoadLastButton}
            isLoadPreviousButton={this.state.isLoadPreviousButton}
            isLoadNextButton={this.state.isLoadNextButton}
            loadFirst={this.loadFirst}
            loadLast={this.loadLast}
            loadNext={this.loadNext}
            loadPrevious={this.loadPrevious}
          />
        )}
        {this.state.isProductStatusListFormOpen && (
          <BaseInquiryToolBar
            onModuleExit={() => this.moduleExit()}
            pageTitle={this.state.pageTitle}
            isShowExitButton={this.state.isShowExitButton}
          />
        )}

        {!this.state.isProductStatusListFormOpen && (
          <BaseToolBar
            back={this.back}
            save={this.save}
            clearError={this.clearError}
            isShowSaveButton={this.state.isShowSaveButton}
            isShowClearErrorButton={this.state.isShowClearErrorButton}
            isShowBackButton={this.state.isShowBackButton}
            pageTitle={this.state.pageTitle}
          />
        )}

        {this.state.isProductStatusListFormOpen && (
          <ProductStatusListForm
            {...this.state}
            onChange={this.onChange}
            editProductStatus={this.editProductStatus}
            goButton={this.goButton}
            enterKeyEventHandler={this.enterKeyEventHandler}
            handleSortingChange={this.handleSortingChange}
          />
        )}

        {this.state.isProductStatusEntryFormOpen && (
          <ProductStatusEntryForm {...this.state} onChange={this.onChange} />
        )}
      </div>
    );
  }
}

function ProductStatusAttributeModule(props) {
  return (
    <div id="moduleContainer" className="module_container">
      <div className="app">
        <ProductStatusList {...props} name="" />
        <br />
      </div>
    </div>
  );
}
export default ProductStatusAttributeModule;
